<template>
  <div>
    <div class="modal show fade modal text-left " style="display: block;" v-if="show">
      <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Update Status
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="validate-form mt-2">
                  <div class="row">
                    <div class="col-12 ">
                      <div class="form-group">
                        <label for="account-name">Status </label>
                        <select v-model="status" class="form-control">
                            <option value="0">Open</option>
                            <option value="1">Close</option>
                            <option value="2">Final Close</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 ">
                      <div class="form-group">
                        <label for="account-name">Comments</label>
                        <textarea
                            type="text"
                            v-model="comments"
                            class="form-control"
                            :class="
                                  errorBag.has('comments') ? 'is-invalid' : ''
                                "
                            name="comments"
                            placeholder="comments"
                            v-validate="'required'"
                        />
                        <small
                            v-show="errorBag.has('comments')"
                            class="invalid-feedback"
                        >{{ "*" + errorBag.first("comments") }}</small
                        >
                      </div>
                    </div>
                  </div>
                <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <SelectOptions
                        label="Department"
                        selectAppend="department"
                        labelValue="name"
                        :filter="{limit:0}"
                        :modelValue.sync="selectedDepartment"
                        :url="getDepartmentsUrl"
                    />
                  </div>
                </div>
                </div>
              <div class="row">
                <div class="col-12">
                  <label for="account-name">Sub Department</label>
                  <select class="form-control" v-model="selectedSubDepartment">
                    <option value="null">Select sub department</option>
                    <option v-for="(item,index) in subDepartments" :value="item._id">{{ item.name }}</option>
                  </select>
                </div>
              </div>
                <div class="row mt-1">
                <div class="col-12">
                  <label>Assign To</label>
                  <select class="form-control" name="assignedTo" v-model="assignedTo"  :class="
                                  errorBag.has('assignedTo') ? 'is-invalid' : ''
                                ">
                    <option :value="null">Select assignee</option>
                    <option v-for="(item,index) in assigneeList" :value="item._id">{{ item.name }}</option>
                  </select>
                  <small
                      v-show="errorBag.has('assignedTo')"
                      class="invalid-feedback"
                  >{{ "*" + errorBag.first("assignedTo") }}</small>
                </div>
                </div>
                </form>
          </div>
          <div class="modal-footer justify-content-center">
<!--            <button type="button" @click="sendCall" class="btn btn-primary mt-2 mr-1">Save changes</button>-->
            <button
                type="button"
                class="btn btn-primary mr-1 d-flex mt-2"
                @click="sendCall"
                :disabled="loading"
            >
              <Loader :loading="loading" size="10px"></Loader>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ['show', 'row', 'index'],
  mounted() {
    // if(this.MerchantsData.length == 0){
    //   this.getMerchantData()
    // }

  },
  data() {
    return {
      list: [],
      MerchantsData:[],
      assignedTo:null,
      loading: false,
      comments: '',
      status: 1,
      subDepartments: [],
      selectedSubDepartment: null,
      selectedDepartment: null,
      getDepartmentsUrl: "v1/cms-get-department",
      // showModal: false,
    };
  },
  methods: {
    customNameForMultiselect({email, first_name}) {
      return `${email} ${first_name}`
    },
    getMerchantData() {
      this.makeRequest("post", "v1/get-merchants", {flag: 'all', type: 3}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.MerchantsData = responseData;
                this.setSelectedMerchantValue();
              }
            }
          }
      );
    },
    setSelectedMerchantValue() {


      if (this.selectedSender == null && this.MerchantsData.length > 0) {
        this.selectedSender = this.MerchantsData[0];

      }

      if (this.selectedReceiver == null && this.MerchantsData.length > 0) {
        this.selectedReceiver = this.MerchantsData[0];

      }
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          let data = {
            caseId:this.row?.id,
            status: this.status,
            comments: this.comments,
            subDepartment: this.selectedSubDepartment,
          }

          if(this.assignedTo){
            data.assignedTo = this.assignedTo
          }

          let url = 'v1/cms-update-case-status'


          this.makeRequest("post", url, data).then(callResponse => {
            this.loading = false;
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                this.$emit('completed',callResponse.response.data.data)
              }
            }
          });
        }
      });
    },
    getAssigneesBySubDepartment()
    {
      let url = 'v1/cms-get-department'
      let data = {
        subDepartmentId: this.row?.subDepartment?._id
      }
      this.makeRequest("post", url, data, {}, false).then(callResponse => {
        this.loading = false;
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          this.assigneeList = callResponse.response?.data?.data?.assigneeIds
          // this.assignedTo = this.row?.assignedTo?._id
          // console.log(this.row)

          // if (code == 200) {
          //   this.$emit('completed',callResponse.response.data.data)
          // }
        }
      });
    }
  },
  watch: {
    show(val) {
      if(val){
        this.status = this.row?.status
        this.selectedDepartment = this.row?.subDepartment?._id
        // this.getAssigneesBySubDepartment()
      }
      this.$nextTick(() => {
        this.comments =  ''
        this.assignedTo = null
      })
    },
    selectedDepartment(val) {
      this.selectedSubDepartment = null
      this.subDepartments = []
      if (val) {
        if (typeof val["subDepartments"] != "undefined") {
          this.subDepartments = val.subDepartments
          if (val.subDepartments.length > 0) {
            this.selectedSubDepartment = val.subDepartments[0]._id
            this.assignedTo = null
          }
        }
      }
    },
    selectedSubDepartment(val) {
      this.assignedTo = null
      let subdepartFullObj = []
      if(val){
        subdepartFullObj = this.selectedDepartment.subDepartments.filter(item=>{
          return item._id == val
        })

        if(subdepartFullObj.length > 0){
          this.assigneeList = subdepartFullObj[0]?.assignees
        }
      }

    },
  }
};
</script>

<style scoped>
.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>
